export default __webpack_public_path__ + "images/a5503777772f731c8bf964b449ad957a.png";